var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('user-banned-modal-handler'),_c('ModalWelcome',{attrs:{"show":_vm.newRegister},on:{"cancel":_vm.cancelHandler}}),(_vm.loadIFrame)?_c('iframe',{attrs:{"width":"0","height":"0","src":_vm.IFrameURL,"frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }